// extracted by mini-css-extract-plugin
export default {"hero":"VenueHero_hero__aOBUY","slide":"VenueHero_slide__0XWbK","active":"VenueHero_active__o5kW-","overlay":"VenueHero_overlay__4ufOy","content":"VenueHero_content__a-fPu"};